import React, { useEffect, useState } from 'react'
import logo from '../../assets/images/logo.png'
import { FormGroup, Label, Input, Button } from 'reactstrap'
import styles from '../../assets/css/rstyling.module.css'
import bg3 from "../../assets/utils/images/originals/citynights.jpg";
import { IoIosEye } from 'react-icons/io'
import { IoIosEyeOff } from 'react-icons/io'
import { useLocation } from 'react-router'
import axios from 'axios'
import reset_password_bg from "../../assets/images/reset_password_bg.jpg";
import { useDispatch } from 'react-redux';
import { forgetPassword } from '../../actions/auth_actions';
import Swal from 'sweetalert'

const AccountRecovery = () => {

    const [email, setEmail] = useState('');
    const dispatch = useDispatch()
    const [err, setError] = useState({
        email: ''
    });

    const removeErr = () => {
        setError({
            email: ''
        })
    }

    const checkValidation = () => {
        removeErr()
        if (email === '') {
            setError((prevState) => ({ ...prevState, email: 'Email is required.' }))
        }
        else {
            return true
        }
    }
    const recoverPassword = () => {
        if (checkValidation()) {
            dispatch(forgetPassword({ email: email }))
                .then(response=> {
                    Swal({
                        title: "Recover email link is sent",
                        text: "Please check email",
                        icon: 'info'
                    });
                })
                .catch(err => {
                    console.log(err.response)
                    Swal({
                        title: err.response ? err.response.data.name : "Error",
                        text: err.response ? err.response.data.content : "Please try again!",
                        icon: 'error'
                    });
                })
        }
    }

    return (
        <>
            <div className="container-fluid">
                <div className="row">

                    <div className="col-lg-4 p-0 d-none d-lg-block">
                        <div className={`h-100 ${styles.gradient_grbl}`}>
                            <div
                                style={{
                                    backgroundImage: "url(" + reset_password_bg + ")",
                                    position: "absolute",
                                    width: "100%",
                                    height: "100%",
                                    opacity: "0.2",
                                    zIndex: "5",
                                    backgroundSize: "cover",
                                    top: 0,
                                    left: 0
                                }} />

                        </div>
                    </div>

                    <div className="col-lg-8 col-md-12 bg-white">

                        {/* Logo */}
                        <ul class="nav justify-content-end">
                            <li class="nav-item">
                                <img src={logo} alt="logo" width="150px" style={{ margin: '2rem 1rem 0 0' }} />
                            </li>
                        </ul>

                        <div className="row">
                            <div className="col-lg-9 col-md-10 col-sm-12 pt-5 mt-5">

                                <div className="justify-content-center align-self-center ml-5">
                                    <h4 className="mb-0 ml-3">
                                        <h3 className="text-dark mb-2" style={{ fontWeight: '500' }}>Recover your Account</h3>
                                        <p style={{ fontSize: '1rem' }}>Please enter your Account Email address to recover it.</p>
                                    </h4>

                                    <div className="col-md-10">
                                        <FormGroup className="mt-5">
                                            <Label className={styles.password}>Email
                                                <Input type="email" onChange={(e) => setEmail(e.target.value)}
                                                    placeholder="Enter your Email" className={err.email ? styles.is_invalid + " mt-2" : 'valid mt-2'} />
                                            </Label>
                                            <small className="text-danger">
                                                {err.email}
                                            </small>

                                        </FormGroup>
                                    </div>
                                    <div className="col-md-10">

                                        <div className="mt-4 d-flex align-items-center">
                                            <h6 className="mb-0">
                                                <a href="/login" style={{ color: '#006FA7', fontSize: '0.9rem' }}>
                                                    Login to existing account
                                                </a>
                                            </h6>
                                            <div className="ml-auto">
                                                <Button className={`${styles.bg_blue} btn-hover-shine w-100`} onClick={() => recoverPassword()}>Recover Password</Button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </>
    )
}

export default AccountRecovery
